import DataTable from 'components/datatable';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound404 from 'components/NotFound404';
import Spinner from 'components/Spinner';
import Error from 'components/Error';
import Search from 'containers/search';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import { bindActionCreators } from 'redux';
import hasRole from 'util/hasRole';
import { updateSearchTermsAction, searchApplicantsAction, resetApplicantsAction} from 'ducks/lessonsReport';
import { resetWorkItem } from 'ducks/workItem';
import SelectedApplicant from 'components/applicant/SelectedApplicant';
import { combineCourseToTerms } from '../../util/SearchUtil';

const filteredLessons = (lessons, searchTerms) => lessons
  .filter(l =>((l.examClasses || []).map(item => item.name).includes(searchTerms.examClass) && l.lessonType === searchTerms.lessonType));

class LessonReport extends React.Component {

  selectedApplicantPreviousFn = () => {
    this.props.searchApplicants(this.props.searchTerms);
    this.props.resetWorkItem();
  };

  componentWillUnmount() {
      this.props.resetApplicants();
  }

  render() {

    const {
      loggedUser,
      loadingError,
      loading,
      saving,
      lessons,
      searchTerms,
      updateSearchTerms,
      error,
      searchApplicants,
      applicants,
      selectedApplicant,
      workItemError,
      workItemLoading,
    } = this.props;

    const isAllowed = hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA', 'KULTU_SEURANTA_KATSELIJA']);

    if (isAllowed) {
      return (
        <Container
          textAlign='center'
          pb={7}>
          <ErrorBoundary>
            {saving && <Spinner />}

            {!selectedApplicant.applicant &&
            <Container>
              <Search
                searchType={"LESSONS_REPORT"}
                updateSearchTerms={updateSearchTerms}
                searchTerms={searchTerms}
                searchFn={(searchTerms) => {searchApplicants(searchTerms)}}
              />

              {!!loading.applicants && !loadingError && <Spinner />}
              {loadingError && <Error message={loadingError.message} />}
              {!!applicants && applicants.length > 0 && !loading.applicants &&
              <DataTable
                tableType={'LESSONS_REPORT'}
                rows={applicants}
                rowKey='entityId'
                lessons={filteredLessons(lessons, searchTerms)}
                tableMaxHeight='57vh'
                tableHeight='auto'
              />
              }

              {error && <Error message={error.message} />}

            </Container>
            }
            {!!selectedApplicant.applicant &&
            !loading.applicants &&
            <Container>
              <SelectedApplicant
                {...selectedApplicant}
                error={workItemError}
                loading={workItemLoading}
                previousFn={this.selectedApplicantPreviousFn} />
            </Container>
            }

          </ErrorBoundary>
        </Container>
      );
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />;
    }
  }
}

LessonReport.propTypes = {
  loggedUser: PropTypes.object,
  saving: PropTypes.bool,
  loading: PropTypes.object,
  error: PropTypes.object,
  loadingError: PropTypes.object,
  lessons: PropTypes.array,
  searchTerms: PropTypes.object,
  applicants: PropTypes.array,

};

const mapStateToProps = (state) => {
  return {
    loggedUser: state.userState.user,
    saving: state.applicantLessonStatus.loading.saving,
    loading: state.lessonsReport.loading,
    loadingError: state.general.error,
    lessons: state.general.lessons,
    searchTerms: combineCourseToTerms(state.lessonsReport.searchTerms, state.userState.currentCourse),
    error: state.lessonsEdit.error,
    applicants: state.lessonsReport.applicants,
    selectedApplicant: state.workItem.selectedApplicant
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateSearchTerms: (searchTerms) => updateSearchTermsAction(searchTerms),
  searchApplicants: (searchTerms) => searchApplicantsAction(searchTerms),
  resetWorkItem: () => resetWorkItem(),
  resetApplicants: () => resetApplicantsAction(),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LessonReport);


// WEBPACK FOOTER //
// ./src/containers/lessonReport/index.js